import React, { useState } from "react";
import Logo from "../img/spinoff-light-logo.png";
import "../css/footer.css";
import { Link } from "react-router-dom";

function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage("Please enter your email.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_Backend_URL}/emailsubscribe/submitsubscribemail`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();
      setMessage(data.message);

      if (response.ok) {
        setEmail(""); // Clear the input field
      }
    } catch (error) {
      setMessage("Something went wrong. Please try again later.");
    }
  };

  return (
    <footer className="site-footer footer-large footer-dark footer-wide">
      <div className="footer-top overlay-wraper">
        <div className="overlay-main" />
        <div className="container">
          <div className="row">
            {/* Left Section */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="widget widget_about">
                <div className="logo-footer clearfix p-b15">
                  <a href="index.html">
                    <img src={Logo} alt="" />
                  </a>
                </div>
                <p>
                  SPINOFF Technopark Ltd, having its Corporate office in Chandigarh,
                  and two manufacturing units in Punjab  leads in
                  SMART LED lighting, Inverters & Lithium Battery Energy solutions with
                  over 35 years of industry expertise and cutting-edge
                  manufacturing capabilities.
                </p>
                <ul className="social-icons sx-social-links">
                  <li>
                    <a
                      href="https://www.linkedin.com/company/finikelithium"
                      className="fa fa-linkedin"
                    />
                    Lithium
                  </li>
                  <span>&nbsp;</span>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/SPINOFFTECHNOPARK"
                      className="fa fa-linkedin"
                    />
                    Spinoff
                  </li>
                </ul>
              </div>
            </div>

            {/* Useful Links */}
            <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
              <div className="widget widget_services inline-links">
                <h5 className="widget-title">Useful links</h5>
                <ul>
                  <li>
                    <Link to="/about-us">About</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/our-infrastructure">Our Infrastructure</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Corporate Address */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="widget widget_address_outer">
                <h5 className="widget-title1">Contact Us</h5>
                <ul className="widget_address">
                  <h5>Corporate Address</h5>
                  <li>SCO-117/118, Sec-43B, Chandigarh-160022</li>
                  <li>sales@spinoff.in</li>
                  <li>+91 97780-44000</li>
                {/*  <h5>NOIDA Sales Office</h5>
                  <li>Mr Arvind Mishra </li>
                  <li>+91 9599531291</li>*/}
                  <h5>Overseas Sales Office</h5>
                  <li>
                    Unit 9/35/37 Jesica Rd, Campbellfield VIC 3061, Australia
                  </li>
                  <li>sales@spinoff.in</li>
                  <li>+91 97780-44000</li>
                </ul>
              </div>
            </div>

            {/* Factory Address */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="widget widget_address_outer">
                <h5 className="widget-title2">Contact Us</h5>
                <ul className="widget_address">
                  <h5>Factory Address 1</h5>
                  <li>
                    E-226, Ph-8B, Ind Area, SAS Nagar, Mohali, Punjab-160071
                  </li>
                  <li>sales@spinoff.in</li>
                  <li>+91 97780-44000</li>
                  <h5>Factory Address 2</h5>
                  <li>NH1, Village Aluna,Soanti,Teh-Rajpura,Distt patiala Rajpura, Punjab</li>
                  <li>sales@spinoff.in</li>
                  <li>+91 97780-44000</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Subscribe Form */}
        <div className="container">
          <div className="call-to-action-wrap">
            <div className="row">
              <div className="col-lg-7 col-md-6">
                <div className="call-to-action-left">
                  <h5 className="text-uppercase m-b10 m-t0">Subscribe us!</h5>
                  <span>For getting new product solutions</span>
                </div>
              </div>
              <div className="col-lg-5 col-md-6">
                <div className="call-to-action-right">
                  <div className="widget_newsletter">
                    <div className="newsletter-bx">
                      <form onSubmit={handleSubscribe}>
                        <div className="input-group">
                          <input
                            type="email"
                            value={email}
                            name="email"
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control"
                            placeholder="ENTER YOUR EMAIL"
                            required
                          />
                          <span className="input-group-btn">
                            <button type="submit" className="site-button">
                              <i className="fa fa-paper-plane-o" />
                            </button>
                          </span>
                        </div>
                      </form>
                      {message && (
                        <p className="subscribe-message">{message}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom overlay-wraper">
        <div className="overlay-main" />
        <div className="container">
          <div className="row">
            <div className="sx-footer-bot-left">
              <span className="copyrights-text">
                © 2024 Spinoff Technopark Ltd. All Rights Reserved
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
